var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfiguration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_175_18785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.625 5.92004V0.625C8.625 0.279785 8.34521 0 8 0C7.65479 0 7.375 0.279785 7.375 0.625V5.92004C6.48022 6.18909 5.82654 7.01941 5.82654 8C5.82654 8.98059 6.48035 9.81091 7.375 10.08V15.375C7.375 15.7202 7.65479 16 8 16C8.34521 16 8.625 15.7202 8.625 15.375V10.08C9.51978 9.81091 10.1735 8.98059 10.1735 8C10.1735 7.01941 9.51978 6.18909 8.625 5.92004ZM8 8.92188C7.49084 8.92188 7.07654 8.5083 7.07654 8C7.07654 7.4917 7.49084 7.07812 8 7.07812C8.50916 7.07812 8.92346 7.4917 8.92346 8C8.92346 8.5083 8.50916 8.92188 8 8.92188ZM2.79846 11.7482V0.625C2.79846 0.279785 2.51868 0 2.17346 0C1.82825 0 1.54846 0.279785 1.54846 0.625V11.7482C0.653809 12.0172 0 12.8477 0 13.8281C0 15.0256 0.974976 16 2.17346 16C3.37195 16 4.34692 15.0256 4.34692 13.8281C4.34692 12.8477 3.69324 12.0172 2.79846 11.7482ZM2.17346 14.75C1.66431 14.75 1.25 14.3364 1.25 13.8281C1.25 13.3198 1.66431 12.9062 2.17346 12.9062C2.68274 12.9062 3.09692 13.3198 3.09692 13.8281C3.09692 14.3364 2.68274 14.75 2.17346 14.75ZM13.8265 0C12.6281 0 11.6531 0.974365 11.6531 2.17188C11.6531 3.15234 12.3068 3.98279 13.2015 4.25183V15.375C13.2015 15.7202 13.4813 16 13.8265 16C14.1718 16 14.4515 15.7202 14.4515 15.375V4.25183C15.3462 3.98279 16 3.15234 16 2.17188C16 0.974365 15.025 0 13.8265 0ZM13.8265 3.09375C13.3173 3.09375 12.9031 2.68018 12.9031 2.17188C12.9031 1.66357 13.3173 1.25 13.8265 1.25C14.3357 1.25 14.75 1.66357 14.75 2.17188C14.75 2.68018 14.3357 3.09375 13.8265 3.09375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_175_18785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiguration);
export default __webpack_public_path__ + "static/media/Configuration.5174d85b21687a055083eb5f4bab625c.svg";
export { ForwardRef as ReactComponent };